import { alpha, styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

export const Root = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  padding: '2rem 0',
  height: '100%',
});

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: alpha(theme.palette.primary.darker, 0.7),
  textAlign: 'center',
  lineHeight: 1.5,
  whiteSpace: 'pre-line',
  fontWeight: 500,
}));

export const StyledButton = styled(Button)({
  minWidth: '220px',
  marginTop: '1.5rem',
});
